import { render } from "./CoursePanelInformation.vue?vue&type=template&id=148c1056&scoped=true"
import script from "./CoursePanelInformation.vue?vue&type=script&lang=js"
export * from "./CoursePanelInformation.vue?vue&type=script&lang=js"

import "./CoursePanelInformation.vue?vue&type=style&index=0&id=148c1056&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148c1056"]])

export default __exports__